import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatablePokja = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      width: '100px',
      cell: (row) => (
        <>
          <div className="dropdown">
            <button
              className="btn btn-danger btn-sm dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Aksi
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => props.handleCreateAnggota(row)}
                >
                  Tambah Anggota
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => props.handleEdit(row)}
                >
                  Edit
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => props.handleHapus(row.id)}
                >
                  Hapus
                </a>
              </li>
            </ul>
          </div>
        </>
      ),
    },
    {
      name: 'Nama Pokja',
      selector: (row) => row.namaPokja,
    },

    {
      name: 'Anggota',
      cell: (row) => (
        <>
          <span
            type="button"
            className="badge badge-primary"
            onClick={() => props.showParticipant(row)}
          >
            {row.pokja_details.length} Anggota
          </span>
        </>
      ),
    },
    {
      name: 'Created At',
      selector: (row) => row.createdAt,
    },
    {
      name: 'Update At',
      selector: (row) => row.updatedAt,
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Pokja</h5>
      <DataTable
        columns={columns}
        data={props.pokja_header}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Kelompok Kerja"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => {
              // Hanya izinkan huruf, angka, dan spasi
              const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
              props.handleChangeSearch(cleanValue);
            }}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatablePokja;
